export default "__VITE_PUBLIC_ASSET__8297aea9__"